import { Page, NavController, NavParams } from 'ionic-angular'
import { Component, NgZone } from '@angular/core'
import { Http } from '@angular/http'

import { DOMAIN } from '../../config'

import * as L from 'leaflet';

@Component({
  templateUrl: 'build/pages/project/project.html'
})

export class ProjectPage {
  private project: any;
  private geojson: any;
  private map2: any;

  constructor(private nav: NavController, private http: Http, params: NavParams, private zone: NgZone) {
    this.project = Object.assign({}, params.get('project'));
    this.geojson = [];
    this.map2;
  }

  // Come from back transition
  ionViewWillEnter() {
    this.ngAfterViewInit();
  }

  ngAfterViewInit() {
    let mapDiv2 = document.querySelector('.map2') as HTMLElement;
    mapDiv2.style.height = window.innerHeight * 0.9 + 'px';

    let tiles = {
      map: `http://${DOMAIN}/api/tiles/sncf_fond/{z}/{x}/{y}`,
      typos: `http://${DOMAIN}/api/tiles/sncf_typos/{z}/{x}/{y}`,
      symboles: `http://${DOMAIN}/api/tiles/sncf_symboles/{z}/{x}/{y}`
    };

    L.Icon.Default.imagePath = `https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.3/images/`;
    this.map2 = L.map((mapDiv2), {
      zoomControl: false,
      maxBounds: [
        [42.9403, 1.4392],
        [47.8721, 7.7343]
      ]
    });

    L.control.zoom({
      position: 'topright'
    }).addTo(this.map2);

    L.tileLayer(tiles.map, {
      maxZoom: 12,
      minZoom: 6
    }).addTo(this.map2);

    L.tileLayer(tiles.symboles, {
      maxZoom: 12,
      minZoom: 8,
      zIndex: 2
    }).addTo(this.map2);

    let typos = L.tileLayer(tiles.typos, {
      maxZoom: 12,
      minZoom: 6,
      zIndex: 3
    }).addTo(this.map2);


    setTimeout( () => {
    // Create a new container for the typo tiles
      let topPane = this.map2._createPane('leaflet-top-pane', this.map2.getPanes().mapPane);
      topPane.appendChild(typos.getContainer());
      typos.setZIndex(5);
    }, 300)

    // Charger le GTFS
    this.zone.run(() => {
      this.displayProjectGeojson(this.project);
    });

    this.zoomControl();
  }

  ionViewWillLeave() {
    this.map2.remove();
  }

  zoomControl() {
    let geojsons = this.geojson;

    this.map2.on('zoomend', function() {
      for (let geojson of geojsons) {
        for (let layer of geojson.getLayers()) {
          if (this.getZoom() > 8) {
            if (layer.feature.geometry.type === 'Point' && layer.feature.properties.type === 'center') {
              this.removeLayer(layer);
            } else {
              layer.addTo(this);
            }
          } else {
            if (layer.feature.geometry.type === 'Point' && layer.feature.properties.type === 'center') {
              layer.addTo(this);
            } else {
              this.removeLayer(layer);
            }
          }
        }
      }
    });
  }

  displayProjectGeojson(projectSelect) {
    let projects = [];
    if (!projectSelect.id) {
      for (let id of projectSelect.chantiers) {
        projects.push(id);
      }
    } else {
      projects.push(projectSelect.id);
    }
    let projectColor = projectSelect.couleur;

    for (let project of projects) {
      this.http
        .get(`//${DOMAIN}/api/geojson/${project}`)
        .map(res => res.json())
        .subscribe(data => {
          var marker = {
            radius: 8,
            fillColor: projectColor,
            color: '#fff',
            stroke: true,
            weight: 2,
            opacity: 1,
            fillOpacity: 1,
            className: 'path' + project
          };

          for (let feature of data.features) {
            if (feature.properties.type !== 'CP') {
              let line = new L.GeoJSON(feature, {
                // Pour les lignes on leur donne la couleur
                style: function(feature) {
                  if (feature.geometry.type !== 'Point') {
                    return {
                      color: projectColor,
                      opacity: 1,
                      className: 'path' + project
                    };
                  }
                },
                // Pour les points
                pointToLayer: (feature, latlng) => {
                  return L.circleMarker(latlng, marker);
                },
              });
              if ((this.map2.getZoom() > 8 || !this.map2.getZoom()) && feature.geometry.type !== 'Point' && feature.properties.type !== 'center') {
                  this.map2.addLayer(line);
              } else if (this.map2.getZoom() < 8 && feature.geometry.type === 'Point' && feature.properties.type === 'center') {
                  this.map2.addLayer(line)
              }
              this.geojson.push(line);
            }

            this.centerOn();
          }
        });
      }
  }

  centerOn() {
    let bounds = new L.LatLngBounds(null);

    for (let geojson of this.geojson) {
      bounds.extend(geojson.getBounds());
    }

    // Centre la carte sur le/les geojson séléctionné(s)
    this.map2.fitBounds(bounds, {
        minZoom: 6,
        maxZoom: 12
    });
  }

  clickLink(link) {
    if (link.slice(-4) === '.pdf') {
      link = `http://${DOMAIN}/img/chantiers/${link}`;
    }

    window.open(link, '_system');
  }
}
